var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2923 12L9.0461 7.75385C8.95252 7.66027 8.90252 7.54553 8.8961 7.40963C8.88968 7.27373 8.93968 7.15257 9.0461 7.04615C9.15252 6.93974 9.27047 6.88653 9.39995 6.88653C9.52943 6.88653 9.64738 6.93974 9.7538 7.04615L14.1423 11.4346C14.2294 11.5218 14.2907 11.6109 14.3259 11.7019C14.3612 11.7929 14.3788 11.8923 14.3788 12C14.3788 12.1077 14.3612 12.2071 14.3259 12.2981C14.2907 12.3891 14.2294 12.4782 14.1423 12.5654L9.7538 16.9539C9.66022 17.0474 9.54547 17.0974 9.40957 17.1039C9.27367 17.1103 9.15252 17.0603 9.0461 16.9539C8.93968 16.8474 8.88647 16.7295 8.88647 16.6C8.88647 16.4705 8.93968 16.3526 9.0461 16.2462L13.2923 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIcon);
export default __webpack_public_path__ + "static/media/arrow-icon.37a4d2616c473b2c1023dfbc5f2edef4.svg";
export { ForwardRef as ReactComponent };